/* eslint-disable jsx-a11y/anchor-is-valid */
import AdamTextInput from "../AdamTextInput/AdamTextInput";

const Domain = (props) => {
    const regex = new RegExp('www');

    // const invalid = props.value.match(/www/)
    const warn = regex.test(props.value)
    const warnText = warn ? "This must be a valid domain (NO 'www'!!!)" : ""

    let labelText = props.labelText
    if (props.onButtonClicked) {
        labelText = (
            <>
                <span>{labelText}</span>
                <span> </span>
                (<a onClick={() => props.onButtonClicked(props.value)}>{props.labelButtonModal}</a>)
            </>
        )
    }

    props = {
        ...props,
        warn: warn,
        warnText: warnText,
        labelText: labelText
    }
    return (
        <AdamTextInput
            {...props}
        />
    )
}

export default Domain